import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
function AreaDetails()
{
    return(
        <>
  <section
    className="flat-title-page mrg-0 brdgm boder-r-0 "
    style={{
      backgroundImage:
        'url("https://maqaruae.com/images/img/banner-innerpages.jpg")',
      margin: 0
    }}
  >
    <div className="container">
      <div className="breadcrumb-content">
        <h1 className="text-center text-white title">Area Guide</h1>
        <ul className="breadcrumb">
          <li>
            <Link to="/" className="text-white">
              Home
            </Link>
          </li>
          <li>
            <Link to="area-guide"
              className="text-white"
              style={{ textTransform: "capitalize" }}
            >
              /Area Guide
            </Link>
          </li>
          <li className="text-white" style={{ textTransform: "capitalize" }}>
            /Al Barsha
          </li>
        </ul>
      </div>
    </div>
  </section>
  <section className="flat-section flat-recommended ">
    <div className="container">
      <div
        className="flat-tab-recommended flat-animate-tab area-bxs wow fadeInUp"
        data-wow-delay=".2s"
        style={{ visibility: "visible", animationDelay: "0.2s" }}
      >
        <div className="tab-content">
          <div className="tab-pane active show" id="viewAll" role="tabpanel">
            <div className="row align-center">
              <div className=" col-lg-12 col-md-12">
                <div className="homelengo-box">
                  <img
                    src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/68993360-ddad-4625-0f4c-e8d4235ff800/w=1200,sharpen=1"
                    srcSet="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/68993360-ddad-4625-0f4c-e8d4235ff800/w=1200,sharpen=1"
                    style={{
                      transition: "all 0.3s ease",
                      width: "100%",
                      aspectRatio: "13 / 9",
                      objectFit: "cover"
                    }}
                  />
                </div>
              </div>
              <div className=" col-lg-12 col-md-12">
                <div>
                  <h3 className="mb-20" style={{ textTransform: "capitalize" }}>
                    About Al Barsha
                  </h3>
                  <h4>The Area</h4>
                  <p>
                    Al Barsha centres around the Mall of the Emirates and
                    stretches back from Sheikh Zayed Road back towards the Al
                    Khail Road. The accommodation and facilities in Al Barsha 1
                    seem to have built up from around the time the Mall of
                    Emirates was built and it is now a well established area.
                    The area is vibrant and busy and very multi-cultural. There
                    are lots and lots of little supermarkets, salons, tailors,
                    laundries and random independent shops and you can usually
                    find anything you need within a short walk. There are also
                    many many restaurants and take-aways of all description –
                    from Middle Easter to Italian, from European bakery to KFC!
                    There is also the City Max hotel which offers food and drink
                    and the sports bar is a great place to catch the match on a
                    Saturday evening.
                  </p>
                  <h4>Accommodation Options</h4>
                  <p>
                    In Al Barsha 1 there are only apartments available, within
                    mainly low rise buildings. There are blocks which are old
                    and established as well as new ones springing up at the back
                    of Al Barsha going towards Al Khail Road. The buildings are
                    mostly independently owned and therefore the management and
                    upkeep is variable. I am lucky that my building has a great
                    management company who are active in keeping in touch with
                    the tenants and any maintenance is done efficiently.
                  </p>
                  <h4>Why I like Living Here</h4>
                  <p>
                    Mainly I like the location of Al Barsha because it is so
                    convenient for getting around Dubai. It is easy to get onto
                    Sheikh Zayed Road or Al Khail Road, and it is serviced by
                    the main artery road Umm Sequeim Street. Whilst at peak
                    times traffic can be congested, it is usually fairly quick
                    to come in and out of the centre of Al Barsha 1.
                  </p>
                  <p>
                    I also love the convenience and random nature of all the
                    shops and salons which surround my building. The fact that I
                    can walk to the Mall of Emirates or Lulu’s supermarket is
                    also a bonus, as is being able to get a cab (usually) fairly
                    easily from the side of the street.
                  </p>
                  <p>
                    The rents in Al Barsha 1 tend to be a little lower than in
                    other more glamorous areas, so that also makes living here a
                    good option for me as a single lady.
                  </p>
                  <p>
                    It can be a little noisy at times in Al Barsha 1 with people
                    on the streets and cars hooting their horns in traffic,
                    however, with the door closed it never bothers me.
                  </p>
                  <p>
                    This area would suit busy single people who are want a
                    central location in town and are on a budget.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</>

    )
}
    export default AreaDetails;